export default class Debouncer {

    constructor(delay = null) {
        this.delay = delay || 500;
        this.debounceTimer = null;
    }

    /**
     * Run callable but make sure to debounce
     */
    handle(callable, delay = null) {
        if (this.debounceTimer) {
            this.cancel();
        }

        this.debounceTimer = window.setTimeout(() => {
            callable();
            this.debounceTimer = null;
        }, delay || this.delay);
    }

    /**
     * Cancel the action
     */
    cancel() {
        window.clearTimeout(this.debounceTimer);
    }

    /**
     * Set a debouncer container
     * https://levelup.gitconnected.com/debounce-in-javascript-improve-your-applications-performance-5b01855e086
     */
    container(func, delay = null) {
        return (...args) => {
            this.handle(() => {
                func(...args)
            }, delay);
        }
    }

    /**
     * Is bouncing
     */
    isBouncing() {
        return !! this.debounceTimer;
    }
}
